// server/middleware/ping.js
export default defineEventHandler((event) => {
  return new Response("pong", {
    status: 200,
    headers: {
      "Content-Type": "text/plain",
    },
  });
});
